import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { QuickbooksExport } from './QuickbooksExport'
import { QuickbooksExportMapper } from './QuickbooksExportMapper'

export class QuickbooksExportCollection {
  protected collection: string = 'quickbooksExport'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchQuickbooksExport(id: string): { data: QuickbooksExport | null } {
    const query = this.initQuery()
    return query.watch(id)
  }

  getQuickbooksExport(id: string): Promise<QuickbooksExport | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  list(): Promise<QuickbooksExport[]> {
    const query = this.initQuery()
    return query.list()
  }

  listQuickbooksExportsByOrderIdAndCompanyId(orderId: string, companyId: string): Promise<QuickbooksExport[]> {
    const query = this.initQuery()
    query.setQuery(this.getQuickbooksExportsByArrayContainsAndCompanyId(query, 'orderIds', orderId, companyId))
    return query.list()
  }

  async getQuickbooksExportByRestaurantCompanyId(restaurantCompanyId: string): Promise<QuickbooksExport | null> {
    const query = this.initQuery()
    query.setQuery(this.getQuickbooksExportsByRestaurantCompanyIdQuery(query, restaurantCompanyId).limit(1))
    const quickbooksExports = await query.list()
    return quickbooksExports.length ? quickbooksExports[0] : null
  }

  save(quickbooksExport: QuickbooksExport): Promise<QuickbooksExport> {
    const query = this.initQuery()
    return query.save(quickbooksExport)
  }

  delete(quickbooksExport: QuickbooksExport) {
    const query = this.initQuery();
    return query.delete(quickbooksExport)
  }

  protected initQuery(): FirestoreQuery<QuickbooksExport> {
    const query = new FirestoreQuery<QuickbooksExport>(this.db, new QuickbooksExportMapper())
    query.collection(this.collection)

    return query
  }

  protected getQuickbooksExportsByRestaurantCompanyIdQuery(query: FirestoreQuery<QuickbooksExport>, restaurantCompanyId: string) {
    return this.getQuickbooksExportsByFieldValue(query, 'exportedByCompanyId', restaurantCompanyId)
  }

  protected getQuickbooksExportsByFieldValue(query: FirestoreQuery<QuickbooksExport>, field: string, value: any) {
    return query.collection(this.collection).where(field, '==', value)
  }

  protected getQuickbooksExportsByArrayContainsAndCompanyId(query: FirestoreQuery<QuickbooksExport>, arrayField: string, value: any, companyId: string) {
    return query.collection(this.collection).where(arrayField, 'array-contains', value).where('exportedByCompanyId', '==', companyId)
  }
}
